import * as React from 'react';

import { cn } from '@/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, onFocus, onWheel, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-gold-dark focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50',
          type === 'number'
            ? 'appearance-none [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none'
            : '',
          className
        )}
        ref={ref}
        onFocus={(e) => {
          if (type === 'number' && e.target.value === '0') {
            e.target.value = '';
          }
          onFocus?.(e);
        }}
        onWheel={(e) => {
          if (type === 'number') {
            (e.target as HTMLInputElement).blur();
          }
          onWheel?.(e);
        }}
        {...props}
      />
    );
  }
);
Input.displayName = 'Input';

export { Input };
